<app-home-page-card>
  <app-home-page-card-header
    [title]="'HOME_PAGE.SETUP_CHECKLIST.TITLE'"
    imageUrl="images/home-checklist.png"
    data-chmln="chameleon-checklist"
  >
    <p [innerHTML]="'HOME_PAGE.SETUP_CHECKLIST.SUBTITLE' | translate"></p>
  </app-home-page-card-header>
  <div class="dashboard-setup-checklist"></div>
  <app-home-page-card-footer
    [ctaButtons]="[
      {
        text: 'HOME_PAGE.SETUP_CHECKLIST.CTA',
        url: '',
        queryParams: '',
      },
    ]"
    [expandable]="false"
    [buttonAction]="true"
    (actionClicked)="dismissChecklist()"
  >
  </app-home-page-card-footer>
</app-home-page-card>
